import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";

import {
  Dialog,
  DialogContent,
  CloseButton,
} from "./styles";
import { showSupportDialog } from "../../../store/dialogs/dialogsActions";

const SupportDialog = (props) => {
  const { openSupportDialog, showSupportDialog } = props;

  return (
    <Dialog
      open={openSupportDialog}
      onClose={() => showSupportDialog(false)}
    >
      <DialogContent>
        <h4>Support</h4>
        <p>Message us via your private client <Link to="#" className="dark-light">Slack</Link> channel <Link to="#">here</Link> for any system issues.</p>
        {/*<Link to="#">hello@alchemymachines.ai</Link>*/}
        <div className="divider">
          <div className="line"/>
          <p>Or</p>
          <div className="line"/>
        </div>
        <p>You can email us at: <a href="mailto:hello@alchemymachines.ai">hello@alchemymachines.ai</a></p>
        <p className="footer-text">We will aim to respond within 1 hour. Thank you!</p>
      </DialogContent>
      <CloseButton className="close-icon" onClick={() => showSupportDialog(false)}>
        X
      </CloseButton>
    </Dialog>
  );
};

const mapStateToProps = (state) => ({
  openSupportDialog: state.dialogsReducer.openSupportDialog,
});

const mapDispatchToProps = {
  showSupportDialog
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SupportDialog));
